import React, { useCallback, useState } from "react";

import ConfirmModal from "../ConfirmModal";

const DeficiencyReviewPanel = ({ step, steps, handleAction }: any) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStep, setSelectedStep] = useState(step - 1);
  const [action, setAction] = useState("");
  const [message, setMessage] = useState("Are you sure?");
  const [note, setNote] = useState("");

  const showModal = useCallback(
    (action: any, message: any, selectedStep?: any) => {
      console.log("showModal", action, message, selectedStep);
      setAction(action);
      setMessage(message);
      setModalOpen(true);
    },
    []
  );

  return (
    <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 mb-8">
      <div className="px-4 py-5 sm:px-6 bg-gray-50">
        <h2 className="font-bold text-gray-700">Update Deficient Record</h2>
      </div>
      <div className="px-4 py-5 sm:p-6 ">
        <div className="col-span-6 sm:col-span-3 mb-4">
          <label
            htmlFor="country"
            className="block text-sm font-medium text-gray-700"
          >
            Step
          </label>
          <select
            id="step"
            name="step"
            autoComplete="step"
            defaultValue={selectedStep}
            onChange={(event: any) => {
              setSelectedStep(parseInt(event.target.value));
            }}
            className="mt-1 block w-full py-2 px-3 border bg-gray-50 border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            {steps.map((step: any, i: number) => {
              return (
                <option key={i} value={i}>
                  {step.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="mb-4">
          <label
            htmlFor="comments"
            className="block text-sm font-medium text-gray-700"
          >
            Notes
          </label>
          <div className="mt-1">
            <textarea
              id="comments"
              name="comments"
              onChange={(event: any) => setNote(event.target.value)}
              rows={3}
              className="shadow-sm focus:ring-blue-500 bg-gray-50 focus:border-blue-500 block w-full sm:text-sm border border-gray-300 rounded-md"
              placeholder="Enter comments here..."
              defaultValue={""}
            />
          </div>
        </div>

        <div className="flex justify-end">
          <button
            disabled={!note}
            title="Save note but do not change status"
            onClick={() =>
              showModal(
                "note",
                "This will add a note to the application but will not change its status or step in the process."
              )
            }
            className="py-2 px-4 border bg-gradient-to-b from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600  border-gray-300 rounded-md shadow-sm text-sm font-medium text-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Add Note
          </button>
          <button
            disabled={!note}
            title='This will record your note, change status to "In Progress", and update the current step if applicable'
            onClick={() =>
              showModal(
                "update",
                "This will add a note to this application and move it to a different step if a new step is selected.",
                selectedStep
              )
            }
            className="ml-3 bg-gradient-to-b from-green-600 to-green-700 hover:from-green-500 hover:to-green-600  focus:ring-green-500 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50  disabled:cursor-not-allowed"
          >
            Update Record
          </button>
          <button
            title="This will permanently mark the application as rejected"
            disabled={!note}
            onClick={() =>
              showModal(
                "admin-reject",
                "Rejecting this application will pernanently mark the application as rejected and will NOT notify the applicant."
              )
            }
            className="ml-3 bg-gradient-to-b from-red-600 to-red-700 hover:from-red-500 hover:to-red-600  inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-red-500 disabled:cursor-not-allowed"
          >
            Reject
          </button>
        </div>
      </div>
      {modalOpen && (
        <ConfirmModal
          message={message}
          handleClose={() => {
            setModalOpen(false);
          }}
          handleAction={() => {
            handleAction(action, note, selectedStep);
          }}
        />
      )}
    </div>
  );
};

export default DeficiencyReviewPanel;
